export default __webpack_public_path__ + "static/meetYourNewDigitalProfile-bb7007b2d90007801c12fde7e13ebe7f.png";